module.exports = __webpack_public_path__ + "static/media/mobile-verybadnight-cover.17e205f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/mobile-verybadnight-cover.jpg
// module id = 578
// module chunks = 0